import VuexPersistence from 'vuex-persist'

export default new VuexPersistence({
	key: 'urlstate',
	storage: window.localStorage,
	reducer: currentState => ({
		urlstate: {
			states: currentState.urlstate.states,
		},
	}),
}).plugin
